@import 'tailwindcss';

:host {
    font-family: Effra, Helvetica, Arial, sans-serif !important;
    font-synthesis: none;
    font-size: 16px;
    text-rendering: optimizeLegibility;
    --root-font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    --colour-white: #fff;
    --colour-charcoal-dark: #0b0b0b;
    --colour-charcoal-light: #1d1d1d;
    --colour-gold: #cc9900;
    --colour-grey: #c6c6c6;
    --colour-grey-light: #bbbbbb;
    --colour-grey-light-50: rgba(187, 187, 187, 0.5);
    --colour-grey-dark: #4b4b4b;
    --colour-pale: #707070;

    --colour-interest-blue: #e5f7fd;
    --colour-interest-green: #edf6ea;
    --colour-interest-purple: #f5daf2;
    --colour-interest-yellow: #faf5e5;
    --colour-interest-gold: #cc99001a;
    --colour-interest-pink: #fff6ff;
    --colour-interest-orange: #fff0e5;

    --tw-border-style: solid;

    background-color: var(--colour-charcoal-light);
}

@theme {
    /* override rems with ems */
    --spacing: 4px;
    --text-xs: 0.75em;
    --text-sm: 14px;
    --text-base: 16px;
    --text-lg: 1.125em;
    --text-xl: 1.25em;
    --text-2xl: 1.5em;
    --text-3xl: 1.875em;
    --radius-md: 0.375em;
    --radius-lg: 0.5em;
    --radius-2xl: 1em;
}

.map {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    font-size: 16px;

    .mazemap-ctrl-logo-wrapper {
        left: auto !important;
        right: 15px !important;
        bottom: 10px !important;
    }

    .mapboxgl-popup-close-button {
        width: 30px;
        height: 30px;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        line-height: 1;
        top: 4px;
        right: 4px;
        border-radius: 50%;
        transition: background-color 0.2s;

        &:hover {
            background-color: rgba(0, 0, 0, 0.05);
        }
    }

    .mapboxgl-ctrl-bottom-right {
        bottom: 45px;
    }

    .custom-maze-marker {
        /* Mimics 'circle-radius': 8 (total diameter 16px) */
        width: 16px;
        height: 16px;
        /* Set the background color - you can make this dynamic later */
        background-color: #007bff; /* Example color, replace with actual GeoJSON color */
        /* Make it a circle */
        border-radius: 50%;
        /* Mimics 'circle-stroke-width': 2 and 'circle-stroke-color': '#fff' */
        border: 2px solid #fff;
        /* Ensures the center of the element is aligned with the marker's location */
        transform: translate(-50%, -50%);
        /* Optional: Add a subtle shadow for depth */
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
    }
}
